import api from '../api';

export const fetchOperatorIdByUserId = async (id: string): Promise<number> => {
  const { data } = await api.get(`/users/${id}`);
  return data;
};

export const fetchUserProfile = async (id: string): Promise<{ name: string }> => {
  const { data } = await api.get(`/users/${id}/profile`);
  return data;
};
